import axios from 'axios'
// import store from '../store'

// 创建axios实例
const service = axios.create({
// baseURL: process.env.BASE_API, // api 的 base_url
  timeout: 30000 , // 请求超时时间
})

// request拦截器
service.interceptors.request.use(
  config => {
    if (global.memberId) { // config.headers['Accept'] = 'application/json' // 让每个请求携带自定义token 请根据实际情况自行修改
      config.headers['memberId'] = global.memberId//
    }
    return config
  },
  error => {
    // Promise.reject(error.response.data.message)
  }
)

// response 拦截器
service.interceptors.response.use(
  response => {
    // console.log(response)
    /**
     * code为非20000是抛错 可结合自己业务进行修改
     */
    const res = response.request
    //  console.log(response)
    if (response.status!= 200) {
      // 50008:非法的token; 50012:其他客户端登录了;  50014:Token 过期了;
      //    if (res.code === 50008 || res.code === 50012 || res.code === 50014) {

      //    }
      return Promise.reject('error')
    } else {
      return response.data
    }
  },
  error => {
    // return Promise.reject(error.response.data.message)
  }
)

export default service



// WEBPACK FOOTER //
// ./src/utils/chaosiRequest.js